var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.noShop)?_c('the-c-shop-content-first-no-shop'):_vm._e(),_c('the-c-shop-content-second'),_c('the-create-shop-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }